import dayjs from "dayjs";
import React from "react";
import { toast } from "react-toastify";
import YouTube from "react-youtube";
import { Translate } from "../../locales/locales-utils";
import { getVideoIdFromYoutubeUrl } from "../../utils";
import { AnnouncementDto } from "../announcements/types";
import { RefButton } from "../like-button-ref/like-button-ref";
import { useStyles } from "./style";
import "dayjs/locale/ru";
import { getCurrentLang } from "../../locales/locales-utils";
import { GAME_SITE_URL } from 'gatsby-env-variables-fork';
import { VideoPlayer } from '../video-player/video-player';

type Props = {
  model: AnnouncementDto;
};

const MEDIA_WIDTH = 392;
const MEDIA_HEIGHT = 220;

const formatStartDate = (date: Date, locale: string) => {
  const startDate = dayjs(date);
  const formattedDate = startDate.locale(locale).format("D MMMM");
  const time = startDate.format("HH:mm");
  return `${formattedDate} / ${time}`;
};

export const AnnouncementCard = ({ model }: Props) => {
  const classes = useStyles();
  const language = getCurrentLang();

  return (
    <div className={classes.announcementCard}>
      <div className={`MediaType${model.MediaType} MediaCard ` + classes.announcementCardMedia}>
        {model.MediaType === "Video" && (
          <YouTube
            opts={{
              width: MEDIA_WIDTH,
              height: MEDIA_HEIGHT,
              enableJsApi: 1,
              AutoPlay: 0,
            }}
            videoId={getVideoIdFromYoutubeUrl(model.MediaUrl)}
            loading="lazy"
          />
        )}
        {model.MediaType === "VideoRutube" && (
          <div>
            <iframe
              title="rutube video"
              frameBorder={0}
              allowFullScreen
              allow="lipboard-write; autoplay; gyroscope;"
              src={model.MediaUrl}
              loading="lazy"
            ></iframe>
          </div>
          )
        }
        {(model.MediaType === "Image" || model.MediaType === "Gif") && (
          <div
            style={{
              backgroundImage: `url(${model.MediaUrl})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center"
            }}
          ></div>
        )}
        {model.MediaType === "VideoSelfHosted" && (
          <>
            <VideoPlayer videoUrl={model.MediaUrl} thumbnailUrl={model.MediaThumbnailUrl} />
          </>
        )}
      </div>
      <div className={classes.announcementCardInfo}>
        {language && (
          <div className={`h4 ${classes.announcementCardInfoDate}`}>
            {formatStartDate(model.StartDate, language)}
          </div>
        )}
        <div className={`h2 ${classes.announcementCardInfoTitle}`} title={model.Theme}>{model.Theme}</div>
        {model.Description &&
            <div
                className={`h6 ${classes.announcementCardInfoDescription}`}
                title={model.Description.replace(/<[^>]+>/g, '')}
                dangerouslySetInnerHTML={{ __html: model.Description }}
            >
            </div>
        }
        {model.PrizeDescription && (
          <div title={model.PrizeDescription} className={`h6 ${classes.announcementCardInfoPrize}`}>{model.PrizeDescription}</div>
        )}
        <div className={classes.announcementCardInfoActions}>
          <div className={classes.announcementCardInfoCode}>
          <span className={`h6 ${classes.announcementCardInfoCodeTitle}`}>
            {Translate("Index.Announcements.GameCode")}
          </span>
            <input
              readOnly
              type={"text"}
              value={model.Code}
              className={`h3 ${classes.announcementCardInfoCodeInput}`}
            ></input>
            <div
              onClick={() => {
                navigator.clipboard.writeText(model.Code);
                toast.info(Translate("Index.Announcements.CodeCopied"));
              }}
              className={classes.announcementCardInfoCodeCopy}
            ></div>
          </div>
            <RefButton
              onClick={() => {
                if (typeof window !== "undefined") {
                  window.location.href = `${GAME_SITE_URL}/p/${model.Code}`;
                }
              }}
              text={
                model.IsFinished
                  ? Translate("Index.Announcements.Completed")
                  : Translate("Index.Announcements.Participate")
              }
              variant={"primary"}
              size={"lg"}
              classNames={classes.announcementCardInfoButton}
              disabled={model.IsFinished}
              tag="button"
            />
        </div>
      </div>
    </div>
  );
};
